var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('AdminDialog',{attrs:{"displayed":_vm.adminDialog.displayed,"message":_vm.lastPopMessage},on:{"update:displayed":function($event){return _vm.$set(_vm.adminDialog, "displayed", $event)}}}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }